import * as THREE from "three";

/**
 * A planet surface
 */
export class PlanetSurface {
    /**
     * Get the average color of an image
     * @param {CanvasRenderingContext2D} context The canvas context
     * @param {number} width The canvas width
     * @param {number} height The canvas height
     * @returns {Color} The average color
     */
    static getAverageImageColor(context, width, height) {
        let r = 0;
        let g = 0;
        let b = 0;

        const data = context.getImageData(0, 0, width, height).data;

        for (let y = 0; y < height; ++y) for (let x = 0; x < width; ++x) {
            const index = (y * width + x) << 2;

            r += data[index];
            g += data[index + 1];
            b += data[index + 2];
        }

        return new THREE.Color(
            r / (width * height * 255),
            g / (width * height * 255),
            b / (width * height * 255));
    }

    /**
     * Construct a planet surface
     */
    constructor() {
        this.color = null;
    }

    /**
     * Get the surface texture
     * @returns {Texture} The surface texture
     */
    get texture() {
        return null;
    }

    /**
     * Load the planet surface
     * @param {WebGLRenderer} renderer The renderer
     * @returns {Promise} A promise that resolves when this surface is usable
     */
    load(renderer) {
        return new Promise(resolve => {
            resolve();
        });
    }

    /**
     * Update
     * @param {number} delta The time delta
     */
    update(delta) {

    }

    /**
     * Update before rendering
     * @param {WebGLRenderer} renderer The renderer
     * @param {number} time The time interpolation in the range [0, 1]
     */
    render(renderer, time) {
        
    }
}